export const IntroSpecial = (
  <>
    <span className='brown-text light strong'> Node.js Back-end,</span>
    <span className='brown-text light'>Full Stack Node.js React Developer</span>
  </>
);
